<template>
<div class="d-flex">
	<!-- Sidebar menu (hide if < lg) -->
	<div
		class="d-none d-lg-flex flex-column sticky-top top-1 bg-body-tertiary border-radius"
		:class="{
			'p-1 pe-3 m-0 mt-2 ms-2 me-1 me-xl-2': isDesktop,
			'': isMobile,
		}"
		style="height: min-content; width: auto;"
	>
		<div class="p-1">
			<a class="nav-link text-nowrap align-text-bottom" href="#common-settings">
				<unit-icon />
				Загальні налаштування
			</a>
		</div>

		<div class="p-1">
			<a class="nav-link text-nowrap align-text-bottom" href="#power-unit" @click="spoilersShow['power-unit'] = true">
				<unit-icon unitType="power" />
				Силовий модуль
			</a>
		</div>
		<div
			v-for="section in Object.values(powerUnit.sections)" :key="section.anchor"
			class="p-1 ps-4"
		>
			<a
				class="nav-link text-nowrap align-text-bottom"
				:class="{
					'fw-bold': section.intersectionRatio == 1,
					'fw-semibold': section.intersectionRatio >= 0.5 && section.intersectionRatio < 1,
				}"
				:href="'#' + section.anchor"
				@click="spoilersShow['power-unit'] = true"
			>
				<span class="font-monospace">
					<span v-if="section.intersectionRatio == 1">●</span>
					<span v-else-if="section.intersectionRatio >= 0.5 && section.intersectionRatio < 1">•</span>
					<span v-else>&nbsp;</span>
				</span>
				{{ section.title }}
			</a>
		</div>

		<div class="p-1">
			<a class="nav-link text-nowrap align-text-bottom" href="#service-unit" @click="spoilersShow['service-unit'] = true">
				<unit-icon unitType="service" />
				Сервісний модуль
			</a>
		</div>
		<div
			v-for="section in Object.values(serviceUnit.sections)" :key="section.anchor"
			class="p-1 ps-4"
		>
			<a
				class="nav-link text-nowrap align-text-bottom"
				:class="{
					'fw-bold': section.intersectionRatio == 1,
					'fw-semibold': section.intersectionRatio >= 0.5 && section.intersectionRatio < 1,
				}"
				:href="'#' + section.anchor"
				@click="spoilersShow['service-unit'] = true"
			>
				<span class="font-monospace">
					<span v-if="section.intersectionRatio == 1">●</span>
					<span v-else-if="section.intersectionRatio >= 0.5 && section.intersectionRatio < 1">•</span>
					<span v-else-if="section.intersectionRatio > 0 && section.intersectionRatio < 0.5">・</span>
					<span v-else>&nbsp;</span>
				</span>
				{{ section.title }}
			</a>
		</div>
		
		<div class="p-1">
			<a class="nav-link text-nowrap align-text-bottom" href="#electric-meter-unit" @click="spoilersShow['electric-meter-unit'] = true">
				<unit-icon unitType="power_meter" />
				{{ Station.unitNames[Station.passportKeys.electricMeter.self] }}
			</a>
		</div>

		<div class="p-1">
			<a class="nav-link text-nowrap align-text-bottom" href="#modem-unit" @click="spoilersShow['modem-unit'] = true">
				<unit-icon unitType="modem" />
				Модем
			</a>
		</div>
		<div
			v-for="section in Object.values(modemUnit.sections)" :key="section.anchor"
			class="p-1 ps-4"
		>
			<a
				class="nav-link text-nowrap align-text-bottom"
				:class="{
					'fw-bold': section.intersectionRatio == 1,
					'fw-semibold': section.intersectionRatio >= 0.5 && section.intersectionRatio < 1,
				}"
				:href="'#' + section.anchor"
				@click="spoilersShow['modem-unit'] = true"
			>
				<span class="font-monospace">
					<span v-if="section.intersectionRatio == 1">●</span>
					<span v-else-if="section.intersectionRatio >= 0.5 && section.intersectionRatio < 1">•</span>
					<span v-else-if="section.intersectionRatio > 0 && section.intersectionRatio < 0.5">・</span>
					<span v-else>&nbsp;</span>
				</span>
				{{ section.title }}
			</a>
		</div>

		<div class="p-1">
			<a class="nav-link text-nowrap align-text-bottom" href="#breaker" @click="spoilersShow['breaker'] = true">
				<unit-icon unitType="breaker" />
				Переривач
			</a>
		</div>
		<div
			v-for="section in Object.values(breaker.sections)" :key="section.anchor"
			class="p-1 ps-4"
		>
			<a
				class="nav-link text-nowrap align-text-bottom"
				:class="{
					'fw-bold': section.intersectionRatio == 1,
					'fw-semibold': section.intersectionRatio >= 0.5 && section.intersectionRatio < 1,
				}"
				:href="'#' + section.anchor"
				@click="spoilersShow['breaker'] = true"
			>
				<span class="font-monospace">
					<span v-if="section.intersectionRatio == 1">●</span>
					<span v-else-if="section.intersectionRatio >= 0.5 && section.intersectionRatio < 1">•</span>
					<span v-else-if="section.intersectionRatio > 0 && section.intersectionRatio < 0.5">・</span>
					<span v-else>&nbsp;</span>
				</span>
				{{ section.title }}
			</a>
		</div>
		
		<div class="p-1">
			<a class="nav-link text-nowrap align-text-bottom" style="display: flex;" href="#reports" @click="spoilersShow['reports'] = true">
				<menu-icon name="report" color="currentColor" edgeSize="24" class="pe-2"/>
				Звіти
			</a>
		</div>
	</div>

	<!-- Settings -->
	<div
		class="flex-grow-1 p-0 m-0"
		:class="{'pe-1': isDesktop}"
	>
		<!-- Alert cards -->
		<template v-for="(alert, index) in taskAlerts" :key="index">
			<Transition name="rpc-alert">
				<div
					v-if="alert.show"
					class="row m-0 p-0 g-2 my-0 mt-2 w-100 card border-radius"
				>
					<div class="card-header position-relative m-0 p-3" :class="[alert.background, ]">
						<span class="fw-bold text-nowrap position-absolute top-50 start-0 translate-middle-y ps-3">
							{{ alert.title }}
						</span>

						<span class="font-monospace text-nowrap position-absolute top-50 start-50 translate-middle d-none d-lg-block">
							{{ alert.task }}&nbsp;&nbsp;&nbsp;&nbsp;{{ alert.state }}
						</span>

						<button
							class="position-absolute top-50 end-0 translate-middle-y pb-1 px-2"
							type="button"
							:class="['btn-close', alert.background, ]"
							aria-label="Close"
							style="opacity: initial;"
							@click="alert.show = false"
						/>
					</div>
					<div class="card-body p-1 px-3 mt-0">
						<template v-for="([key, value], index) in Object.entries(alert.context.settings)" :key="index">
							<p class="card-text mb-0">
								<span class="font-monospace"><b>{{ settingName(key) }}</b> = {{ value }}</span>
							</p>
						</template>
					</div>
				</div>
			</Transition>
		</template>

		<!-- Main content -->
		<!-- Common settings -->
		<a id="common-settings" />
		<drop-down-spoiler v-model:show="spoilersShow['common-settings']" :sticky-title="true">
			<template v-slot:title>
				<div class="row row-cols-3 justify-content-between">
					<div class="col-auto text-nowrap d-flex">
						<unit-icon unitType="power" />&nbsp;
						<h6 class="fs-5 fw-bold text-nowrap m-0">Загальні налаштування</h6>
					</div>
					<div class="col-auto m-0 p-0 ms-3 me-1">
						<h6
							class="font-monospace text-truncate m-0 p-0"
							:class="{
								'text-danger': false,
								'text-success': false,
							}"
						>
							{{ }}
						</h6>
					</div>

					<div class="col-auto m-0 p-0 ms-auto me-0 d-none d-xl-block d-xxl-block">
						<button
							v-show="commonSettings.isSubmitActive"
							type="submit"
							class="btn btn-primary btn-sm"
							style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;"
							:disabled="!commonSettings.isSubmitActive"
							@click.stop="commonSettings.submit()"
						>
							Записати
						</button>
					</div>
				</div>
			</template>
			<template v-slot:body>
				<common-settings
					v-if="isSettingsLoad"
					:class="{
						'px-2': isDesktop,
						'px-0': isMobile,
					}"
					:station-id="stationId"
					@save-function-active="(f) => commonSettings.isSubmitActive = f"
					@save-function="(f) => commonSettings.submit = f"
				/>
			</template>
		</drop-down-spoiler>

		<!-- Power unit -->
		<a id="power-unit" />
		<drop-down-spoiler v-model:show="spoilersShow['power-unit']" :sticky-title="true">
			<template v-slot:title>
				<div class="row row-cols-3 justify-content-between">
					<div class="col-auto text-nowrap d-flex">
						<unit-icon unitType="power" />&nbsp;
						<h6 class="fs-5 fw-bold text-nowrap m-0">Силовий модуль</h6>
					</div>
					<div class="col-auto m-0 p-0 ms-3 me-1">
						<h6
							class="font-monospace text-truncate m-0 p-0"
							:class="{
								'text-danger': false,
								'text-success': false,
							}"
						>
							{{ }}
						</h6>
					</div>

					<div class="col-auto m-0 p-0 ms-auto me-0 d-none d-xl-block d-xxl-block">
						<button
							v-show="powerUnit.isSubmitActive"
							type="submit"
							class="btn btn-primary btn-sm"
							style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;"
							:disabled="!powerUnit.isSubmitActive"
							@click.stop="powerUnit.submit()"
						>
							Записати
						</button>
					</div>
				</div>
			</template>
			<template v-slot:body>
				<power-unit-settings
					v-if="isSettingsLoad"
					:class="{
						'px-2': isDesktop,
						'px-0': isMobile,
					}"
					:station-id="stationId"
					@sections="(sections) => powerUnit.sections = sections"
					@save-function-active="(f) => powerUnit.isSubmitActive = f"
					@save-function="(f) => powerUnit.submit = f"
				/>
			</template>
		</drop-down-spoiler>

		<!-- Service unit -->
		<a id="service-unit" />
		<drop-down-spoiler v-model:show="spoilersShow['service-unit']" :sticky-title="true">
			<template v-slot:title>
				<div class="row row-cols-3 justify-content-between">
					<div class="col-auto text-nowrap d-flex">
						<unit-icon unitType="service" />&nbsp;
						<h6 class="fs-5 fw-bold text-nowrap m-0">Сервісний модуль</h6>
					</div>

					<div class="col-auto m-0 p-0 ms-3 me-1">
						<h6
							class="font-monospace text-truncate m-0 p-0"
							:class="{
								'text-danger': false,
								'text-success': false
							}"
						>
						</h6>
					</div>

					<div class="col-auto m-0 p-0 ms-auto me-0 d-none d-xl-block d-xxl-block">
						<button
							v-show="serviceUnit.isSubmitActive"
							type="submit"
							class="btn btn-primary btn-sm"
							style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;"
							:disabled="!serviceUnit.isSubmitActive"
							@click.stop="serviceUnit.submit()"
						>
							Записати
						</button>
					</div>
				</div>
			</template>
			<template v-slot:body>
				<service-unit-settings
					v-if="isSettingsLoad"
					:class="{
						'px-2': isDesktop,
						'px-0': isMobile,
					}"
					:station-id="stationId"
					@rpc="(rpc) => updateRpc(rpc)"
					@sections="(sections) => serviceUnit.sections = sections"
					@save-function-active="(f) => serviceUnit.isSubmitActive = f"
					@save-function="(f) => serviceUnit.submit = f"
				/>
			</template>
		</drop-down-spoiler>

		<!-- Electric meter unit -->
		<a id="electric-meter-unit"></a>
		<drop-down-spoiler v-model:show="spoilersShow['electric-meter-unit']" :sticky-title="true">
			<template v-slot:title>
				<div class="row row-cols-3 justify-content-between">
					<div class="col-auto text-nowrap d-flex">
						<unit-icon unitType="power_meter" />&nbsp;
						<h6 class="fs-5 fw-bold text-nowrap m-0">{{ Station.unitNames[Station.passportKeys.electricMeter.self] }}</h6>
					</div>

					<div class="col-auto m-0 p-0 ms-3 me-1">
						<h6
							class="font-monospace text-truncate m-0 p-0"
							:class="{
								'text-danger': rpcTaskSchema.state.isErorrState(),
								'text-success': !rpcTaskSchema.state.isErorrState()
							}"
						>
							{{ }}
						</h6>
					</div>

					<div class="col-auto m-0 p-0 ms-auto me-0 d-none d-xl-block d-xxl-block">
						<button
							v-show="electricMeterUnit.isSubmitActive"
							type="submit"
							class="btn btn-primary btn-sm"
							style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;"
							:disabled="!electricMeterUnit.isSubmitActive"
							@click.stop="electricMeterUnit.submit()"
						>
							Записати
						</button>
					</div>
				</div>
			</template>
			<template v-slot:body>
				<ElectricMeterUnitSettings
					v-if="isSettingsLoad"
					:class="{
						'px-2': isDesktop,
						'px-0': isMobile,
					}"
					:station-id="stationId"
					@save-function-active="(f) => electricMeterUnit.isSubmitActive = f"
					@save-function="(f) => electricMeterUnit.submit = f"
				/>
			</template>	
		</drop-down-spoiler>

		<!-- Modem unit -->
		<a id="modem-unit"></a>
		<drop-down-spoiler v-model:show="spoilersShow['modem-unit']" :sticky-title="true">
			<template v-slot:title>
				<div class="row row-cols-3 justify-content-between">
					<div class="col-auto text-nowrap d-flex">
						<unit-icon unitType="modem" />&nbsp;
						<h6 class="fs-5 fw-bold text-nowrap m-0">Модем</h6>
					</div>

					<div class="col-auto m-0 p-0 ms-3 me-1">
						<h6
							class="font-monospace text-truncate m-0 p-0"
							:class="{
								'text-danger': false,
								'text-success': false
							}"
						>
						</h6>
					</div>

					<div class="col-auto m-0 p-0 ms-auto me-0 d-none d-xl-block d-xxl-block">
						<button
							v-show="modemUnit.isSubmitActive"
							type="submit"
							class="btn btn-primary btn-sm"
							style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;"
							:disabled="!modemUnit.isSubmitActive"
							@click.stop="modemUnit.submit()"
						>
							Записати
						</button>
					</div>
				</div>
			</template>
			<template v-slot:body>
				<modem-unit-settings
					v-if="isSettingsLoad"
					:class="{
						'px-2': isDesktop,
						'px-0': isMobile,
					}"
					:station-id="stationId"
					@rpc="(rpc) => updateRpc(rpc)"
					@sections="(sections) => modemUnit.sections = sections"
					@save-function-active="(f) => modemUnit.isSubmitActive = f"
					@save-function="(f) => modemUnit.submit = f"
				/>
			</template>
		</drop-down-spoiler>

		<!-- Breaker unit -->
		<a id="breaker"></a>
		<drop-down-spoiler v-model:show="spoilersShow['breaker']" :sticky-title="true">
			<template v-slot:title>
				<div class="row row-cols-3 justify-content-between">
					<div class="col-auto text-nowrap d-flex">
						<unit-icon unitType="breaker" />&nbsp;
						<h6 class="fs-5 fw-bold text-nowrap m-0">Переривач</h6>
					</div>

					<div class="col-auto m-0 p-0 ms-3 me-1">
						<h6
							class="font-monospace text-truncate m-0 p-0"
							:class="{
								'text-danger': false,
								'text-success': false
							}"
						>
						</h6>
					</div>

					<div class="col-auto m-0 p-0 ms-auto me-0 d-none d-xl-block d-xxl-block">
						<button
							v-show="breaker.isSubmitActive"
							type="submit"
							class="btn btn-primary btn-sm"
							style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;"
							:disabled="!breaker.isSubmitActive"
							@click.stop="breaker.submit()"
						>
							Записати
						</button>
					</div>
				</div>
			</template>
			<template v-slot:body>
				<breaker-settings
					v-if="isSettingsLoad"
					:class="{
						'px-2': isDesktop,
						'px-0': isMobile,
					}"
					:station-id="stationId"
					@rpc="(rpc) => updateRpc(rpc)"
					@sections="(sections) => breaker.sections = sections"
					@save-function-active="(f) => breaker.isSubmitActive = f"
					@save-function="(f) => breaker.submit = f"
				/>
			</template>
		</drop-down-spoiler>

		<!-- Reports -->
		<a id="reports"></a>
		<drop-down-spoiler v-model:show="spoilersShow['reports']" :sticky-title="true">
			<template v-slot:title>
				<div class="row row-cols-3 justify-content-between">
					<div class="col-auto text-nowrap d-flex">
						<menu-icon name="report" color="currentColor" edgeSize="24" />&nbsp;
						<h6 class="fs-5 fw-bold text-nowrap m-0">Звіти</h6>
					</div>

					<div class="col-auto m-0 p-0 ms-3 me-1">
						<h6
							class="font-monospace text-truncate m-0 p-0"
							:class="{
								'text-danger': rpcTaskSchema.state.isErorrState(),
								'text-success': !rpcTaskSchema.state.isErorrState()
							}"
						>
							{{ }}
						</h6>
					</div>

					<div class="col-auto m-0 p-0 ms-auto me-0 d-none d-xl-block d-xxl-block">
						<button
							v-show="reports.isSubmitActive"
							type="submit"
							class="btn btn-primary btn-sm"
							style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;"
							:disabled="!reports.isSubmitActive"
							@click.stop="reports.submit()"
						>
							Записати
						</button>
					</div>
				</div>

				<!-- <h6 class="fs-5 fw-bold m-0">Звіти</h6> -->
			</template>
			<template v-slot:body>
				<ReportSettings
					v-if="isSettingsLoad"
					:class="{
						'px-2': isDesktop,
						'px-0': isMobile,
					}"
					:station-id="stationId"
					@save-function-active="(f) => reports.isSubmitActive = f"
					@save-function="(f) => reports.submit = f"
				/>
			</template>
		</drop-down-spoiler>
	</div>
</div>
</template>




<script>
import DropDownSpoiler from '@/components/DropDownSpoiler.vue'
import UnitIcon from '@/components/Icons/UnitIcon.vue'
import MenuIcon from '@/components/Icons/MenuIcon.vue'
import ModemUnitSettings from '@/components/StationView/ModemUnitSettings.vue'
import PowerUnitSettings from '@/components/StationView/PowerUnitSettings.vue'
import ServiceUnitSettings from '@/components/StationView/ServiceUnitSettings.vue'
import ElectricMeterUnitSettings from './ElectricMeterUnitSettings.vue'
import BreakerSettings from './BreakerSettings.vue'
import ReportSettings from './ReportSettings.vue'
import CommonSettings from './CommonSettings.vue'
import { useSizeBreakpoint } from '@/composables/size-breakpoint.js'
import { useStationsStore } from '@/stores/StationsStore.js'
import { rpcTaskSchema } from '@/composables/rpcTasks.js'
import { Station } from '@/models/station.js'
import { ServiceUnit } from '@/models/serviceUnit.js'
import { ModemUnit } from '@/models/modemUnit.js'
import { Breaker } from '@/models/breaker.js'
import { capitalizeFirstLetter } from '@/helpers'


export default {
	components: {
		DropDownSpoiler,
		UnitIcon,
		MenuIcon,
		ModemUnitSettings,
		PowerUnitSettings,
		ServiceUnitSettings,
		ElectricMeterUnitSettings,
		BreakerSettings,
		ReportSettings,
		CommonSettings,
	},

	props: {
		stationId: {
			type: String,
			require: true,
		},
	},

	setup() {
		const { isDesktop, isMobile } = useSizeBreakpoint()
		const stationsStore = useStationsStore()

		return {
			isDesktop,
			isMobile,
			stationsStore,
			Station,
			rpcTaskSchema,
		}
	},

	data() {
		return {
			isSettingsLoad: false,

			taskAlerts: [
				// {
				// 	title: 'Тест',
				// 	promt: 'приклад повідомлення про помилку',
				// 	background: 'bg-danger-subtle',
				// 	show: true,
				// }
			],

			// !key exactly as is!
			spoilersShow: {
				'common-settings': true,
				'power-unit': false,
				'service-unit': false,
				'electric-meter-unit': false,
				'modem-unit': false,
				'breaker': false,
				'reports': false,
			},

			commonSettings: {
				submit: () => {},
				isSubmitActive: false,
			},

			powerUnit: {
				sections: [],
				submit: () => {},
				isSubmitActive: false,
			},

			serviceUnit: {
				sections:[],
				submit: () => {},
				isSubmitActive: false,
			},

			electricMeterUnit: {
				submit: () => {},
				isSubmitActive: false,
			},

			modemUnit: {
				sections: [],
				submit: () => {},
				isSubmitActive: false,
			},

			breaker: {
				sections: [],
				submit: () => {},
				isSubmitActive: false,
			},

			reports: {
				submit: () => {},
				isSubmitActive: false,
			},
		}
	},

	
	watch: {},

	created() {
		this.spoilersShow[this.$route.hash?.substring(1)] = true

		// Read station passport
		this.stationsStore.readPassport(
			(result) => { this.isSettingsLoad = result },
			this.stationId
		)
	},

	mounted() {},

	methods: {
		updateRpc(rpc) {
			// console.log('rpc', rpc._id)
			const stateObj = rpcTaskSchema.state.findState(rpc?.state)
			if (stateObj != undefined && stateObj != false) {
				this.pushCard(rpc)
			}
		},

		pushCard(rpc) {
			const unitNames = {
				[Station.passportKeys.serviceUnit.self]: 'сервісний модуль',
				[Station.passportKeys.modemUnit.self]: 'модем',
				[Station.passportKeys.breaker.self]: 'переривач',
			}

			const card = {
				rpcId: rpc._id,
				title: capitalizeFirstLetter(unitNames[rpc.context.unit]),
				task: `${rpcTaskSchema.job.findJob(rpc.job)?.title} `,
				state: `${rpcTaskSchema.state.findState(rpc.state)?.title}`,// (${dateTimeToString(rpc[rpcTaskSchema.updateTime.key], false)})`,
				background: rpcTaskSchema.state.isErorrState(rpc.state) ? 'bg-danger-subtle' : 'bg-success-subtle',
				show: true,
				context: rpc.context,
			}

			const alert = this.taskAlerts.find(
				(alert) => alert.rpcId == card.rpcId
			)

			if (alert == undefined) {
				this.taskAlerts.push(card)
			} else {
				alert.title = card.title
				alert.task = card.task
				alert.state = card.state
				alert.background = card.background
				alert.context = card.context
			}
		},

		settingName(key) {
			if (ModemUnit.settingNames[key]) {
				return ModemUnit.settingNames[key]
			} else if (ServiceUnit.settingNames[key]) {
				return ServiceUnit.settingNames[key]
			} else if (Breaker.settingNames[key]) {
				return Breaker.settingNames[key]
			} else {
				return `Невідомий регістр ${key}`
			}
		},
	},

	computed: {
		station() { return this.stationsStore.station(this.stationId) },
	},
}
</script>




<style scoped>
.rpc-alert-enter-active,
.rpc-alert-leave-active {
  transition: max-height 0.9s ease, opacity 0.9s ease, transform 0.9s ease;
}

.rpc-alert-enter-from,
.rpc-alert-leave-to {
  max-height: 0;
  opacity: 0;
  transform: translateY(-20px);
}

.rpc-alert-enter-to {
  max-height: 2048px;
  opacity: 1;
  transform: translateY(0);
}

.rpc-alert-leave-from {
  max-height: 2048px;
  opacity: 1;
  transform: translateY(0);
}
</style>
